/* eslint-disable arrow-body-style */
import { addBookItem } from '../actionCreators';

const addBook = book => {
  return async dispatch => {
    const response = await fetch('http://localhost:9000/books', {
      method: 'POST',
      body: JSON.stringify({
        ...book
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    });
    const newBook = await response.json();

    dispatch(addBookItem(newBook));
  };
};

export default addBook;
